import { stringifyNode } from '@prezly/content-renderer-react-js';
import { HeadingNode, ParagraphNode } from '@prezly/story-content-format';
import type { Node } from '@prezly/story-content-format';

import { hasId, type TopLevelNodeWithId } from '@/lib/types/content-renderer';
import { slugify } from '@/lib/util/strings/slugify';

/**
 * @see DEV-11066
 */
const TABLE_OF_CONTENTS_MARKER = '<TOC>';

export function isHeadingOneNode(node: Node): node is HeadingNode {
    return HeadingNode.isHeadingNode(node, HeadingNode.Type.HEADING_ONE);
}

export function isHeadingTwoNode(node: Node): node is HeadingNode {
    return HeadingNode.isHeadingNode(node, HeadingNode.Type.HEADING_TWO);
}

export function isParagraphWithTocMarker(node: Node): node is ParagraphNode {
    return (
        ParagraphNode.isParagraphNode(node) &&
        stringifyNode(node).trim() === TABLE_OF_CONTENTS_MARKER
    );
}

export function slugifyNodeText(node: Node): string {
    return slugify(stringifyNode(node)) as string;
}

export function getNodeId(node: TopLevelNodeWithId): string {
    return hasId(node) ? node.id : slugifyNodeText(node);
}
